import first from './assets/first.png';
import second from './assets/second.png';
import third from './assets/third.png';
import fourth from './assets/fourth.png';

export const ROW_SOURCES = [first, second, third, fourth];

export const ROW_HEIGHT = 85;
export const GAP = 8;
export const STEP = ROW_HEIGHT + GAP;
export const ROW_LAST_INDEX = 3;
